module.exports = __webpack_public_path__ + "static/media/salad.f83d3ea5.svg";